/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionCode } from '../../models/promotion-code';

export interface ApiMasterPromotionCodeGetAllGet$Params {
}

export function apiMasterPromotionCodeGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterPromotionCodeGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromotionCode>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPromotionCodeGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PromotionCode>>;
    })
  );
}

apiMasterPromotionCodeGetAllGet.PATH = '/api/Master/PromotionCode/GetAll';
